import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HTTPCONSTANTS } from '../http/http-constants';

/* Names Finder — client for `process=names-resolve`.
   Contract: names build pack task5-finder-architecture.md + 03-page-spec §6.
   One service, three consumers (Finder, hero validation, Out of Reach
   validation), so the substitution set has a single source of truth.
   Shares the Names Register base (same /search host, different process). */

export type ResolveVerdict = 'can-write' | 'can-write-no-record' | 'cannot-write';
export type ResolveOutcome =
  | 'ROMANISATION_REQUIRED'
  | 'INVALID_INPUT'
  | 'RATE_LIMITED';

export interface ResolveArrangement {
  registration: string;
  display: string;
  era: 'dateless' | 'suffix' | 'prefix' | 'current';
  substitutions: number;
  inRegister: boolean;
  existence: 'in-register' | 'evidence-excluded' | 'no-record';
  state: 'new-issue' | 'resale' | 'previously-sold' | 'held' | 'unknown' | null;
  pricePence: number | null;
  detailUrl: string;
}

export interface ResolveResponse {
  input: { raw: string; normalised: string; normalisation: string };
  /** present for the three core verdicts */
  verdict?: ResolveVerdict;
  /** present instead of `verdict` for guidance/validation outcomes */
  outcome?: ResolveOutcome;
  arrangements?: ResolveArrangement[];
  reason?: {
    code: 'TOO_LONG' | 'BLOCKED_LETTERS';
    detail: { length?: number; ceiling?: number; letters?: string[] };
  } | null;
  message?: string;
  availabilityJoined?: boolean;
  /** normalised name to route onward to the normal PlateX search (#6/#7) */
  searchTerm?: string;
  arrangementSource?: 'perfect' | 'engine';
  meta?: { engineVersion: string; datasetVersion: number; resolvedAt: string };
}

@Injectable({ providedIn: 'root' })
export class NameResolveService {
  constructor(private httpClient: HttpClient) {}

  public resolve(term: string): Observable<ResolveResponse> {
    const url =
      `${HTTPCONSTANTS.names_register_protocol}${HTTPCONSTANTS.names_register_base}` +
      `?process=names-resolve&term=${encodeURIComponent(term)}`;
    return this.httpClient.get<ResolveResponse>(url);
  }
}
